var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-text"},[_c('label',{attrs:{"for":_vm.id}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('input',_vm._g(_vm._b({attrs:{"id":_vm.id,"type":"text","title":_vm.label}},'input',_vm.$attrs,false),_vm.$listeners))])
}
var staticRenderFns = []

export { render, staticRenderFns }